export const header = {
  color: "#333",
  fontFamily: "Montserrat",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "132%", // You can keep this as a string or convert it to '1.32' for 132%
}
